import React from 'react';

import { Flex } from '@adsk/alloy-react-box';

import BlockRemoveButton from '../../../../../../BlockRemoveButton';
import { PlanPermittedAction, Task, TaskType } from '../../../types';
import PlanTaskTitle from '../../PlanTaskTitle/PlanTaskTitle';
import TaskConnectedIcon from '../../TaskConnectedIcon/TaskConnectedIcon';
import TaskMilestoneIcon from '../../TaskMilestoneIcon/TaskMilestoneIcon';

interface PlanTaskEntityBlockDateSummaryProps {
  task: Task;
  onRemoveClick: () => void;
}

const PlanTaskEntityBlockHeader = ({
  task,
  onRemoveClick,
}: PlanTaskEntityBlockDateSummaryProps) => {
  const canRemoveReference = task.plan?.permittedActions?.includes(
    PlanPermittedAction.WRITE,
  );

  return (
    <Flex
      alignItems="center"
      justifyContent="space-between"
      style={{ gap: '4px' }}
    >
      <Flex alignItems="center" style={{ gap: '8px' }}>
        {task.activityUniqueId && <TaskConnectedIcon />}
        {task.type === TaskType.MILESTONE && <TaskMilestoneIcon />}
        <PlanTaskTitle task={task} />
      </Flex>
      {canRemoveReference && (
        <BlockRemoveButton
          className="PlanTaskPlugin__remove"
          style={{
            visibility: 'hidden',
          }}
          onClick={onRemoveClick}
        />
      )}
    </Flex>
  );
};

export default PlanTaskEntityBlockHeader;
